// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("app/utils/fonts/Poppins-Regular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Poppins";
  src: local("Poppins"), url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

* {
  font-family: 'Poppins' !important;
}


@media screen and (min-width: 576px) {
  .w-sm-auto {
      width: auto !important;
  }
}

@media screen and (min-width: 768px) {
  .w-md-auto {
      width: auto !important;
  }
}

@media screen and (min-width: 992px) {
  .w-lg-auto {
      width: auto !important;
  }
}

@media screen and (min-width: 1200px) {
  .w-xl-auto {
      width: auto !important;
  }
}

@media screen and (min-width: 1400px) {
  .w-xxl-auto {
      width: auto !important;
  }
}

:root {
  --bs-page-bg: #F9F9F9;
  --bs-app-blank-bg: #ffffff;
  --bs-header-desktop-fixed-bg-color: #ffffff;
  --bs-header-desktop-fixed-box-shadow: 0px 10px 30px 0px rgba(82, 63, 105, 0.08);
  --bs-header-desktop-fixed-bg-color: #ffffff;
  --bs-header-desktop-fixed-box-shadow: 0px 10px 30px 0px rgba(82, 63, 105, 0.08);
  --bs-aside-bg-color: #F1F1F4;
  --bs-sidebar-bg-color: #192440;
  --bs-sidebar-tabs-link-bg-color-default: #0e172e;
  --bs-sidebar-tabs-link-bg-color-active: #07122d;
  --bs-sidebar-tabs-link-icon-color-default: #5e6278;
  --bs-sidebar-tabs-link-icon-color-active: #ffffff;
  --bs-sidebar-dashed-border-color: #3e4a69;
  --bs-sidebar-muted-color: #546182;
  --bs-sidebar-muted-bg-color: #0e172e;
  --bs-text-muted: #99A1B7;
  --bs-gray-100: #F9F9F9;
  --bs-gray-100-rgb: 249, 249, 249;
  --bs-gray-200: #F1F1F4;
  --bs-gray-200-rgb: 241, 241, 244;
  --bs-gray-300: #DBDFE9;
  --bs-gray-300-rgb: 219, 223, 233;
  --bs-gray-400: #C4CADA;
  --bs-gray-400-rgb: 196, 202, 218;
  --bs-gray-500: #99A1B7;
  --bs-gray-500-rgb: 153, 161, 183;
  --bs-gray-600: #78829D;
  --bs-gray-600-rgb: 120, 130, 157;
  --bs-gray-700: #4B5675;
  --bs-gray-700-rgb: 75, 86, 117;
  --bs-gray-800: #252F4A;
  --bs-gray-800-rgb: 37, 47, 74;
  --bs-gray-900: #071437;
  --bs-gray-900-rgb: 7, 20, 55;
  --bs-light: #F9F9F9;
  --bs-primary: #1B84FF;
  --bs-secondary: #F9F9F9;
  --bs-success: #17C653;
  --bs-info: #7239EA;
  --bs-warning: #F6C000;
  --bs-danger: #F8285A;
  --bs-dark: #1E2129;
  --bs-primary-active: #056EE9;
  --bs-secondary-active: #DBDFE9;
  --bs-light-active: #FCFCFC;
  --bs-success-active: #04B440;
  --bs-info-active: #5014D0;
  --bs-warning-active: #DEAD00;
  --bs-danger-active: #D81A48;
  --bs-dark-active: #111318;
  --bs-primary-light: #E9F3FF;
  --bs-secondary-light: #F9F9F9;
  --bs-success-light: #DFFFEA;
  --bs-info-light: #F8F5FF;
  --bs-warning-light: #FFF8DD;
  --bs-danger-light: #FFEEF3;
  --bs-dark-light: #F9F9F9;
  --bs-light-light: #ffffff;
  --bs-primary-inverse: #ffffff;
  --bs-secondary-inverse: #252F4A;
  --bs-light-inverse: #252F4A;
  --bs-success-inverse: #ffffff;
  --bs-info-inverse: #ffffff;
  --bs-warning-inverse: #ffffff;
  --bs-danger-inverse: #ffffff;
  --bs-dark-inverse: #ffffff;
  --bs-primary-clarity: rgba(27, 132, 255, 0.2);
  --bs-secondary-clarity: rgba(249, 249, 249, 0.2);
  --bs-success-clarity: rgba(23, 198, 83, 0.2);
  --bs-info-clarity: rgba(114, 57, 234, 0.2);
  --bs-warning-clarity: rgba(246, 192, 0, 0.2);
  --bs-danger-clarity: rgba(248, 40, 90, 0.2);
  --bs-dark-clarity: rgba(30, 33, 41, 0.2);
  --bs-light-clarity: rgba(255, 255, 255, 0.2);
  --bs-light-rgb: 249, 249, 249;
  --bs-primary-rgb: 27, 132, 255;
  --bs-secondary-rgb: 249, 249, 249;
  --bs-success-rgb: 23, 198, 83;
  --bs-info-rgb: 114, 57, 234;
  --bs-warning-rgb: 246, 192, 0;
  --bs-danger-rgb: 248, 40, 90;
  --bs-dark-rgb: 30, 33, 41;
  --bs-text-white: #ffffff;
  --bs-text-primary: #1B84FF;
  --bs-text-secondary: #F9F9F9;
  --bs-text-light: #F9F9F9;
  --bs-text-success: #17C653;
  --bs-text-info: #7239EA;
  --bs-text-warning: #F6C000;
  --bs-text-danger: #F8285A;
  --bs-text-dark: #1E2129;
  --bs-text-muted: #99A1B7;
  --bs-text-gray-100: #F9F9F9;
  --bs-text-gray-200: #F1F1F4;
  --bs-text-gray-300: #DBDFE9;
  --bs-text-gray-400: #C4CADA;
  --bs-text-gray-500: #99A1B7;
  --bs-text-gray-600: #78829D;
  --bs-text-gray-700: #4B5675;
  --bs-text-gray-800: #252F4A;
  --bs-text-gray-900: #071437;
  --bs-border-color: #F1F1F4;
  --bs-border-dashed-color: #DBDFE9;
  --bs-component-active-color: #ffffff;
  --bs-component-active-bg: #1B84FF;
  --bs-component-hover-color: #1B84FF;
  --bs-component-hover-bg: #F9F9F9;
  --bs-component-checked-color: #ffffff;
  --bs-component-checked-bg: #1B84FF;
  --bs-box-shadow-xs: 0 0.1rem 0.75rem 0.25rem rgba(0, 0, 0, 0.05);
  --bs-box-shadow-sm: 0 0.1rem 1rem 0.25rem rgba(0, 0, 0, 0.05);
  --bs-box-shadow: 0 0.5rem 1.5rem 0.5rem rgba(0, 0, 0, 0.075);
  --bs-box-shadow-lg: 0 1rem 2rem 1rem rgba(0, 0, 0, 0.1);
  --bs-input-bg: var(--bs-body-bg);
  --bs-input-color: var(--bs-gray-700);
  --bs-input-solid-color: var(--bs-gray-700);
  --bs-input-solid-bg: var(--bs-gray-100);
  --bs-input-solid-bg-focus: var(--bs-gray-200);
  --bs-input-solid-placeholder-color: var(--bs-gray-500);
  --bs-root-card-box-shadow: 0px 3px 4px 0px rgba(0, 0, 0, 0.03);
  --bs-root-card-border-color: #F1F1F4;
  --bs-tooltip-box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.15);
  --bs-table-striped-bg: rgba(var(--bs-gray-100-rgb), 0.75);
  --bs-table-loading-message-box-shadow: 0px 0px 50px 0px rgba(82, 63, 105, 0.15);
  --bs-dropdown-bg: var(--bs-body-bg);
  --bs-dropdown-box-shadow: 0px 0px 50px 0px rgba(82, 63, 105, 0.15);
  --bs-code-bg: #f1f3f8;
  --bs-code-shadow: 0px 3px 9px rgba(0, 0, 0, 0.08);
  --bs-code-border-color: transparent;
  --bs-code-color: #b93993;
  --bs-symbol-label-color: var(--bs-gray-800);
  --bs-symbol-label-bg: var(--bs-gray-100);
  --bs-symbol-border-color: rgba(var(--bs-body-bg), 0.5);
  --bs-bullet-bg-color: var(--bs-gray-400);
  --bs-scrolltop-opacity: 0;
  --bs-scrolltop-opacity-on: 0.3;
  --bs-scrolltop-opacity-hover: 1;
  --bs-scrolltop-box-shadow: var(--bs-box-shadow);
  --bs-scrolltop-bg-color: var(--bs-primary);
  --bs-scrolltop-bg-color-hover: var(--bs-primary);
  --bs-scrolltop-icon-color: var(--bs-primary-inverse);
  --bs-scrolltop-icon-color-hover: var(--bs-primary-inverse);
  --bs-drawer-box-shadow: 0px 1px 9px -3px rgba(0, 0, 0, 0.05);
  --bs-drawer-bg-color: #ffffff;
  --bs-drawer-overlay-bg-color: rgba(0, 0, 0, 0.2);
  --bs-menu-dropdown-box-shadow: 0px 0px 50px 0px rgba(82, 63, 105, 0.15);
  --bs-menu-dropdown-bg-color: var(--bs-body-bg);
  --bs-menu-heading-color: #99A1B7;
  --bs-menu-link-color-hover: #1B84FF;
  --bs-menu-link-color-show: #1B84FF;
  --bs-menu-link-color-here: #1B84FF;
  --bs-menu-link-color-active: #1B84FF;
  --bs-menu-link-bg-color-hover: #F9F9F9;
  --bs-menu-link-bg-color-show: #F9F9F9;
  --bs-menu-link-bg-color-here: #F9F9F9;
  --bs-menu-link-bg-color-active: #F9F9F9;
  --bs-scrollbar-color: #F1F1F4;
  --bs-scrollbar-hover-color: #DBDFE9;
  --bs-overlay-bg: rgba(0, 0, 0, 0.05);
  --bs-blockui-overlay-bg: rgba(0, 0, 0, 0.05);
  --bs-rating-color-default: #C4CADA;
  --bs-rating-color-active: #FFAD0F;
  --bs-ribbon-label-box-shadow: 0px -1px 5px 0px rgba(30, 33, 41, 0.1);
  --bs-ribbon-label-bg: #1B84FF;
  --bs-ribbon-label-border-color: #0053b4;
  --bs-ribbon-clip-bg: #1E2129;
  --bs-engage-btn-bg: #ffffff;
  --bs-engage-btn-box-shadow: 0px 0px 22px #E0E0E0;
  --bs-engage-btn-border-color: #E8E8E8;
  --bs-engage-btn-color: #252F4A;
  --bs-engage-btn-icon-color: #78829D;
  --bs-engage-btn-color-active: #252F4A;
}





/* .table-responsive {
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}

table.dataTable {
  width: 100% !important;
  margin: 0 !important;
}

.table:not(.table-bordered).table-row-dashed tr {
  border-bottom-width: 1px;
  border-bottom-style: dashed;
  border-bottom-color: var(--bs-border-color);
}

.table:not(.table-bordered) tr:last-child, .table:not(.table-bordered) th:last-child, .table:not(.table-bordered) td:last-child {
  padding-right: 0;
}

.table:not(.table-bordered) tr:first-child, .table:not(.table-bordered) th:first-child, .table:not(.table-bordered) td:first-child {
  padding-left: 0;
}

.table:not(.table-bordered) tr, .table:not(.table-bordered) th, .table:not(.table-bordered) td {
  border-color: inherit;
  border-width: inherit;
  border-style: inherit;
  text-transform: inherit;
  font-weight: inherit;
  font-size: inherit;
  color: inherit;
  height: inherit;
  min-height: inherit;
}

.table:not(.table-bordered) > :not(:last-child) > :last-child > * {
  border-bottom-color: inherit;
}

.table:not(.table-bordered) tr:first-child, .table:not(.table-bordered) th:first-child, .table:not(.table-bordered) td:first-child {
  padding-left: 0;
}
table.dataTable > thead > tr > td:not(.sorting_disabled), table.dataTable > thead > tr > th:not(.sorting_disabled) {
  padding-right: 0;
}

table.dataTable th {
  border-bottom-color: var(--bs-table-border-color);
}

.table > :not(caption) > * > * {
  padding: 0.75rem 0.75rem;
  color: var(--bs-table-color-state, var(--bs-table-color-type, var(--bs-table-color)));
  background-color: var(--bs-table-bg);
  border-bottom-width: 1px;
  box-shadow: inset 0 0 0 9999px var(--bs-table-bg-state, var(--bs-table-bg-type, var(--bs-table-accent-bg)));
}

.table.gy-5 th, .table.gy-5 td {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}

.table:not(.table-bordered) tr:last-child, .table:not(.table-bordered) th:last-child, .table:not(.table-bordered) td:last-child {
  padding-right: 0;
}

.form-check {
  display: block;
  min-height: 1.5rem;
  padding-left: 2.25rem;
  margin-bottom: 0.125rem;
}

.form-check-custom {
  display: flex;
  align-items: center;
  padding-left: 0;
  margin: 0;
}

.form-check-input {
  --bs-form-check-bg: transparent;
  width: 1.75rem;
  height: 1.75rem;
  margin-top: -0.125rem;
  vertical-align: top;
  background-color: var(--bs-form-check-bg);
  background-image: var(--bs-form-check-bg-image);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: 1px solid var(--bs-gray-300);
  appearance: none;
  print-color-adjust: exact;
}

.form-check .form-check-input {
  float: left;
  margin-left: -2.25rem;
}

.form-check-input[type=checkbox] {
  border-radius: 0.45em;
}

.form-check-custom .form-check-input {
  margin: 0;
  float: none;
  flex-shrink: 0;
}

.form-check.form-check-sm .form-check-input {
  height: 1.55rem;
  width: 1.55rem;
}

.form-check.form-check-solid .form-check-input {
  border: 0;
}

.form-check:not(.form-switch) .form-check-input[type=checkbox] {
  background-size: 60% 60%;
}

.form-check.form-check-solid .form-check-input:not(:checked) {
  background-color: var(--bs-gray-200);
} */


.flatpickr-calendar {
  width: 280px!important;
  font-family: inherit;
  border: 0;
  border-radius: 0;
  box-shadow: var(--bs-dropdown-box-shadow);
  background-color: var(--bs-body-bg);
  border-radius: 0.475rem;
}

.flatpickr-weekdays {
  background: transparent;
  text-align: center;
  overflow: hidden;
  width: 100%;
  display: flex;
  align-items: center;
  height: 28px;
}


span.flatpickr-weekday {
  color: var(--bs-gray-800);
  font-size: 1rem;
  font-weight: 600;
}
span.flatpickr-weekday {
  cursor: default;
  font-size: 90%;
  background: transparent;
  color: #0000008a;
  line-height: 1;
  margin: 0;
  text-align: center;
  display: block;
  flex: 1 1;
  font-weight: bolder;
}

.flatpickr-days {
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: flex-start;
  width: 307.875px;
  border: none;
}

.dayContainer {
  padding: 0;
  outline: 0;
  text-align: left;
  width: 307.875px;
  min-width: 307.875px;
  max-width: 307.875px;
  box-sizing: border-box;
  display: inline-block;
  display: flex;
  flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  justify-content: space-around;
  transform: translateZ(0);
  opacity: 1;
}


.flatpickr-day {
  font-size: 1rem;
  border-radius: 0.475rem;
  box-shadow: none !important;
  height: 36px;
  width: 100%;
  max-width: 100%!important;
  margin: 0;
  line-height: 36px;
  color: var(--bs-gray-600);
  margin-top: 0!important;
}


.flatpickr-day {
  background: none;
  border: 1px solid transparent;
  border-radius: 150px;
  box-sizing: border-box;
  color: #393939;
  cursor: pointer;
  font-weight: 400;
  width: 14.2857143%;
  flex-basis: 14.2857143%;
  max-width: 39px;
  height: 39px;
  line-height: 39px;
  margin: 0;
  display: inline-block;
  position: relative;
  justify-content: center;
  text-align: center;
}




.flatpickr-day.selected, .flatpickr-day.startRange, .flatpickr-day.endRange, .flatpickr-day.selected.inRange, .flatpickr-day.startRange.inRange, .flatpickr-day.endRange.inRange, .flatpickr-day.selected:focus, .flatpickr-day.startRange:focus, .flatpickr-day.endRange:focus, .flatpickr-day.selected:hover, .flatpickr-day.startRange:hover, .flatpickr-day.endRange:hover, .flatpickr-day.selected.prevMonthDay, .flatpickr-day.startRange.prevMonthDay, .flatpickr-day.endRange.prevMonthDay, .flatpickr-day.selected.nextMonthDay, .flatpickr-day.startRange.nextMonthDay, .flatpickr-day.endRange.nextMonthDay {
  background-color: #21364B;
  color: white;
}

.bg-warning-reminder { 
  background-color: #F6700E !important;
}

.bg-success-reminder { 
  background-color: #1B6E53 !important;
}

.bg-danger-reminder { 
  background-color: #E01507 !important;
}

.form-check-input:checked {
  background-color: #21364B;
  border-color: #21364B;
}


.pac-container {
  z-index: 1201 !important;
}


.gm-style-iw button[title="Close"] {
  display: none !important;
}

.gm-style-iw-chr {
  display: none;
}

.gm-style .gm-style-iw-c {
  padding: 0;
}

.gm-style-iw-d {
  padding: 0;
  overflow: hidden !important;
}

.listing-carousel {
  display: grid;
  grid-template-columns: 50% 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  grid-auto-flow: row;
}

.listing-carousel-1 {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr 1fr;
  grid-auto-flow: row;
}

.listing-carousel-2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  grid-auto-flow: row;
}


.listing-carousel-item-1 {
  grid-column: 1;
  grid-row: 1 / 3;
}

.listing-carousel-item-2 {
  grid-column: 2;
  grid-row: 1 / 3;
}

@media only screen and (max-width: 1200px) {
  .listing-carousel {
    grid-template-columns: 1fr;
  }

  .listing-carousel-1 {
    grid-template-columns: 1fr;
  }

  .listing-carousel-2 {
    grid-template-columns: 1fr ;
  }
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,8DAAiE;AACnE;;AAEA;EACE,iCAAiC;AACnC;;;AAGA;EACE;MACI,sBAAsB;EAC1B;AACF;;AAEA;EACE;MACI,sBAAsB;EAC1B;AACF;;AAEA;EACE;MACI,sBAAsB;EAC1B;AACF;;AAEA;EACE;MACI,sBAAsB;EAC1B;AACF;;AAEA;EACE;MACI,sBAAsB;EAC1B;AACF;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,2CAA2C;EAC3C,+EAA+E;EAC/E,2CAA2C;EAC3C,+EAA+E;EAC/E,4BAA4B;EAC5B,8BAA8B;EAC9B,gDAAgD;EAChD,+CAA+C;EAC/C,kDAAkD;EAClD,iDAAiD;EACjD,yCAAyC;EACzC,iCAAiC;EACjC,oCAAoC;EACpC,wBAAwB;EACxB,sBAAsB;EACtB,gCAAgC;EAChC,sBAAsB;EACtB,gCAAgC;EAChC,sBAAsB;EACtB,gCAAgC;EAChC,sBAAsB;EACtB,gCAAgC;EAChC,sBAAsB;EACtB,gCAAgC;EAChC,sBAAsB;EACtB,gCAAgC;EAChC,sBAAsB;EACtB,8BAA8B;EAC9B,sBAAsB;EACtB,6BAA6B;EAC7B,sBAAsB;EACtB,4BAA4B;EAC5B,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;EACpB,kBAAkB;EAClB,4BAA4B;EAC5B,8BAA8B;EAC9B,0BAA0B;EAC1B,4BAA4B;EAC5B,yBAAyB;EACzB,4BAA4B;EAC5B,2BAA2B;EAC3B,yBAAyB;EACzB,2BAA2B;EAC3B,6BAA6B;EAC7B,2BAA2B;EAC3B,wBAAwB;EACxB,2BAA2B;EAC3B,0BAA0B;EAC1B,wBAAwB;EACxB,yBAAyB;EACzB,6BAA6B;EAC7B,+BAA+B;EAC/B,2BAA2B;EAC3B,6BAA6B;EAC7B,0BAA0B;EAC1B,6BAA6B;EAC7B,4BAA4B;EAC5B,0BAA0B;EAC1B,6CAA6C;EAC7C,gDAAgD;EAChD,4CAA4C;EAC5C,0CAA0C;EAC1C,4CAA4C;EAC5C,2CAA2C;EAC3C,wCAAwC;EACxC,4CAA4C;EAC5C,6BAA6B;EAC7B,8BAA8B;EAC9B,iCAAiC;EACjC,6BAA6B;EAC7B,2BAA2B;EAC3B,6BAA6B;EAC7B,4BAA4B;EAC5B,yBAAyB;EACzB,wBAAwB;EACxB,0BAA0B;EAC1B,4BAA4B;EAC5B,wBAAwB;EACxB,0BAA0B;EAC1B,uBAAuB;EACvB,0BAA0B;EAC1B,yBAAyB;EACzB,uBAAuB;EACvB,wBAAwB;EACxB,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,0BAA0B;EAC1B,iCAAiC;EACjC,oCAAoC;EACpC,iCAAiC;EACjC,mCAAmC;EACnC,gCAAgC;EAChC,qCAAqC;EACrC,kCAAkC;EAClC,gEAAgE;EAChE,6DAA6D;EAC7D,4DAA4D;EAC5D,uDAAuD;EACvD,gCAAgC;EAChC,oCAAoC;EACpC,0CAA0C;EAC1C,uCAAuC;EACvC,6CAA6C;EAC7C,sDAAsD;EACtD,8DAA8D;EAC9D,oCAAoC;EACpC,yDAAyD;EACzD,yDAAyD;EACzD,+EAA+E;EAC/E,mCAAmC;EACnC,kEAAkE;EAClE,qBAAqB;EACrB,iDAAiD;EACjD,mCAAmC;EACnC,wBAAwB;EACxB,2CAA2C;EAC3C,wCAAwC;EACxC,sDAAsD;EACtD,wCAAwC;EACxC,yBAAyB;EACzB,8BAA8B;EAC9B,+BAA+B;EAC/B,+CAA+C;EAC/C,0CAA0C;EAC1C,gDAAgD;EAChD,oDAAoD;EACpD,0DAA0D;EAC1D,4DAA4D;EAC5D,6BAA6B;EAC7B,gDAAgD;EAChD,uEAAuE;EACvE,8CAA8C;EAC9C,gCAAgC;EAChC,mCAAmC;EACnC,kCAAkC;EAClC,kCAAkC;EAClC,oCAAoC;EACpC,sCAAsC;EACtC,qCAAqC;EACrC,qCAAqC;EACrC,uCAAuC;EACvC,6BAA6B;EAC7B,mCAAmC;EACnC,oCAAoC;EACpC,4CAA4C;EAC5C,kCAAkC;EAClC,iCAAiC;EACjC,oEAAoE;EACpE,6BAA6B;EAC7B,uCAAuC;EACvC,4BAA4B;EAC5B,2BAA2B;EAC3B,gDAAgD;EAChD,qCAAqC;EACrC,8BAA8B;EAC9B,mCAAmC;EACnC,qCAAqC;AACvC;;;;;;AAMA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAgIG;;;AAGH;EACE,sBAAsB;EACtB,oBAAoB;EACpB,SAAS;EACT,gBAAgB;EAChB,yCAAyC;EACzC,mCAAmC;EACnC,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EAIX,aAAa;EAIb,mBAAmB;EACnB,YAAY;AACd;;;AAGA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;EACd,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,kBAAkB;EAClB,cAAc;EAId,SAAO;EACP,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAIhB,aAAa;EAIb,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,oBAAoB;EAEpB,sBAAsB;EACtB,qBAAqB;EAIrB,aAAa;EAEb,eAAe;EACf,mBAAmB;EAGnB,6BAA6B;EAE7B,wBAAwB;EACxB,UAAU;AACZ;;;AAGA;EACE,eAAe;EACf,uBAAuB;EACvB,2BAA2B;EAC3B,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,SAAS;EACT,iBAAiB;EACjB,yBAAyB;EACzB,uBAAuB;AACzB;;;AAGA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,oBAAoB;EAEpB,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAGlB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,SAAS;EACT,qBAAqB;EACrB,kBAAkB;EAIlB,uBAAuB;EACvB,kBAAkB;AACpB;;;;;AAKA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;;AAGA;EACE,wBAAwB;AAC1B;;;AAGA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,2BAA2B;EAC3B,mBAAmB;AACrB;;;AAGA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,2BAA2B;EAC7B;AACF","sourcesContent":["@font-face {\n  font-family: \"Poppins\";\n  src: local(\"Poppins\"), url(\"app/utils/fonts/Poppins-Regular.ttf\");\n}\n\n* {\n  font-family: 'Poppins' !important;\n}\n\n\n@media screen and (min-width: 576px) {\n  .w-sm-auto {\n      width: auto !important;\n  }\n}\n\n@media screen and (min-width: 768px) {\n  .w-md-auto {\n      width: auto !important;\n  }\n}\n\n@media screen and (min-width: 992px) {\n  .w-lg-auto {\n      width: auto !important;\n  }\n}\n\n@media screen and (min-width: 1200px) {\n  .w-xl-auto {\n      width: auto !important;\n  }\n}\n\n@media screen and (min-width: 1400px) {\n  .w-xxl-auto {\n      width: auto !important;\n  }\n}\n\n:root {\n  --bs-page-bg: #F9F9F9;\n  --bs-app-blank-bg: #ffffff;\n  --bs-header-desktop-fixed-bg-color: #ffffff;\n  --bs-header-desktop-fixed-box-shadow: 0px 10px 30px 0px rgba(82, 63, 105, 0.08);\n  --bs-header-desktop-fixed-bg-color: #ffffff;\n  --bs-header-desktop-fixed-box-shadow: 0px 10px 30px 0px rgba(82, 63, 105, 0.08);\n  --bs-aside-bg-color: #F1F1F4;\n  --bs-sidebar-bg-color: #192440;\n  --bs-sidebar-tabs-link-bg-color-default: #0e172e;\n  --bs-sidebar-tabs-link-bg-color-active: #07122d;\n  --bs-sidebar-tabs-link-icon-color-default: #5e6278;\n  --bs-sidebar-tabs-link-icon-color-active: #ffffff;\n  --bs-sidebar-dashed-border-color: #3e4a69;\n  --bs-sidebar-muted-color: #546182;\n  --bs-sidebar-muted-bg-color: #0e172e;\n  --bs-text-muted: #99A1B7;\n  --bs-gray-100: #F9F9F9;\n  --bs-gray-100-rgb: 249, 249, 249;\n  --bs-gray-200: #F1F1F4;\n  --bs-gray-200-rgb: 241, 241, 244;\n  --bs-gray-300: #DBDFE9;\n  --bs-gray-300-rgb: 219, 223, 233;\n  --bs-gray-400: #C4CADA;\n  --bs-gray-400-rgb: 196, 202, 218;\n  --bs-gray-500: #99A1B7;\n  --bs-gray-500-rgb: 153, 161, 183;\n  --bs-gray-600: #78829D;\n  --bs-gray-600-rgb: 120, 130, 157;\n  --bs-gray-700: #4B5675;\n  --bs-gray-700-rgb: 75, 86, 117;\n  --bs-gray-800: #252F4A;\n  --bs-gray-800-rgb: 37, 47, 74;\n  --bs-gray-900: #071437;\n  --bs-gray-900-rgb: 7, 20, 55;\n  --bs-light: #F9F9F9;\n  --bs-primary: #1B84FF;\n  --bs-secondary: #F9F9F9;\n  --bs-success: #17C653;\n  --bs-info: #7239EA;\n  --bs-warning: #F6C000;\n  --bs-danger: #F8285A;\n  --bs-dark: #1E2129;\n  --bs-primary-active: #056EE9;\n  --bs-secondary-active: #DBDFE9;\n  --bs-light-active: #FCFCFC;\n  --bs-success-active: #04B440;\n  --bs-info-active: #5014D0;\n  --bs-warning-active: #DEAD00;\n  --bs-danger-active: #D81A48;\n  --bs-dark-active: #111318;\n  --bs-primary-light: #E9F3FF;\n  --bs-secondary-light: #F9F9F9;\n  --bs-success-light: #DFFFEA;\n  --bs-info-light: #F8F5FF;\n  --bs-warning-light: #FFF8DD;\n  --bs-danger-light: #FFEEF3;\n  --bs-dark-light: #F9F9F9;\n  --bs-light-light: #ffffff;\n  --bs-primary-inverse: #ffffff;\n  --bs-secondary-inverse: #252F4A;\n  --bs-light-inverse: #252F4A;\n  --bs-success-inverse: #ffffff;\n  --bs-info-inverse: #ffffff;\n  --bs-warning-inverse: #ffffff;\n  --bs-danger-inverse: #ffffff;\n  --bs-dark-inverse: #ffffff;\n  --bs-primary-clarity: rgba(27, 132, 255, 0.2);\n  --bs-secondary-clarity: rgba(249, 249, 249, 0.2);\n  --bs-success-clarity: rgba(23, 198, 83, 0.2);\n  --bs-info-clarity: rgba(114, 57, 234, 0.2);\n  --bs-warning-clarity: rgba(246, 192, 0, 0.2);\n  --bs-danger-clarity: rgba(248, 40, 90, 0.2);\n  --bs-dark-clarity: rgba(30, 33, 41, 0.2);\n  --bs-light-clarity: rgba(255, 255, 255, 0.2);\n  --bs-light-rgb: 249, 249, 249;\n  --bs-primary-rgb: 27, 132, 255;\n  --bs-secondary-rgb: 249, 249, 249;\n  --bs-success-rgb: 23, 198, 83;\n  --bs-info-rgb: 114, 57, 234;\n  --bs-warning-rgb: 246, 192, 0;\n  --bs-danger-rgb: 248, 40, 90;\n  --bs-dark-rgb: 30, 33, 41;\n  --bs-text-white: #ffffff;\n  --bs-text-primary: #1B84FF;\n  --bs-text-secondary: #F9F9F9;\n  --bs-text-light: #F9F9F9;\n  --bs-text-success: #17C653;\n  --bs-text-info: #7239EA;\n  --bs-text-warning: #F6C000;\n  --bs-text-danger: #F8285A;\n  --bs-text-dark: #1E2129;\n  --bs-text-muted: #99A1B7;\n  --bs-text-gray-100: #F9F9F9;\n  --bs-text-gray-200: #F1F1F4;\n  --bs-text-gray-300: #DBDFE9;\n  --bs-text-gray-400: #C4CADA;\n  --bs-text-gray-500: #99A1B7;\n  --bs-text-gray-600: #78829D;\n  --bs-text-gray-700: #4B5675;\n  --bs-text-gray-800: #252F4A;\n  --bs-text-gray-900: #071437;\n  --bs-border-color: #F1F1F4;\n  --bs-border-dashed-color: #DBDFE9;\n  --bs-component-active-color: #ffffff;\n  --bs-component-active-bg: #1B84FF;\n  --bs-component-hover-color: #1B84FF;\n  --bs-component-hover-bg: #F9F9F9;\n  --bs-component-checked-color: #ffffff;\n  --bs-component-checked-bg: #1B84FF;\n  --bs-box-shadow-xs: 0 0.1rem 0.75rem 0.25rem rgba(0, 0, 0, 0.05);\n  --bs-box-shadow-sm: 0 0.1rem 1rem 0.25rem rgba(0, 0, 0, 0.05);\n  --bs-box-shadow: 0 0.5rem 1.5rem 0.5rem rgba(0, 0, 0, 0.075);\n  --bs-box-shadow-lg: 0 1rem 2rem 1rem rgba(0, 0, 0, 0.1);\n  --bs-input-bg: var(--bs-body-bg);\n  --bs-input-color: var(--bs-gray-700);\n  --bs-input-solid-color: var(--bs-gray-700);\n  --bs-input-solid-bg: var(--bs-gray-100);\n  --bs-input-solid-bg-focus: var(--bs-gray-200);\n  --bs-input-solid-placeholder-color: var(--bs-gray-500);\n  --bs-root-card-box-shadow: 0px 3px 4px 0px rgba(0, 0, 0, 0.03);\n  --bs-root-card-border-color: #F1F1F4;\n  --bs-tooltip-box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.15);\n  --bs-table-striped-bg: rgba(var(--bs-gray-100-rgb), 0.75);\n  --bs-table-loading-message-box-shadow: 0px 0px 50px 0px rgba(82, 63, 105, 0.15);\n  --bs-dropdown-bg: var(--bs-body-bg);\n  --bs-dropdown-box-shadow: 0px 0px 50px 0px rgba(82, 63, 105, 0.15);\n  --bs-code-bg: #f1f3f8;\n  --bs-code-shadow: 0px 3px 9px rgba(0, 0, 0, 0.08);\n  --bs-code-border-color: transparent;\n  --bs-code-color: #b93993;\n  --bs-symbol-label-color: var(--bs-gray-800);\n  --bs-symbol-label-bg: var(--bs-gray-100);\n  --bs-symbol-border-color: rgba(var(--bs-body-bg), 0.5);\n  --bs-bullet-bg-color: var(--bs-gray-400);\n  --bs-scrolltop-opacity: 0;\n  --bs-scrolltop-opacity-on: 0.3;\n  --bs-scrolltop-opacity-hover: 1;\n  --bs-scrolltop-box-shadow: var(--bs-box-shadow);\n  --bs-scrolltop-bg-color: var(--bs-primary);\n  --bs-scrolltop-bg-color-hover: var(--bs-primary);\n  --bs-scrolltop-icon-color: var(--bs-primary-inverse);\n  --bs-scrolltop-icon-color-hover: var(--bs-primary-inverse);\n  --bs-drawer-box-shadow: 0px 1px 9px -3px rgba(0, 0, 0, 0.05);\n  --bs-drawer-bg-color: #ffffff;\n  --bs-drawer-overlay-bg-color: rgba(0, 0, 0, 0.2);\n  --bs-menu-dropdown-box-shadow: 0px 0px 50px 0px rgba(82, 63, 105, 0.15);\n  --bs-menu-dropdown-bg-color: var(--bs-body-bg);\n  --bs-menu-heading-color: #99A1B7;\n  --bs-menu-link-color-hover: #1B84FF;\n  --bs-menu-link-color-show: #1B84FF;\n  --bs-menu-link-color-here: #1B84FF;\n  --bs-menu-link-color-active: #1B84FF;\n  --bs-menu-link-bg-color-hover: #F9F9F9;\n  --bs-menu-link-bg-color-show: #F9F9F9;\n  --bs-menu-link-bg-color-here: #F9F9F9;\n  --bs-menu-link-bg-color-active: #F9F9F9;\n  --bs-scrollbar-color: #F1F1F4;\n  --bs-scrollbar-hover-color: #DBDFE9;\n  --bs-overlay-bg: rgba(0, 0, 0, 0.05);\n  --bs-blockui-overlay-bg: rgba(0, 0, 0, 0.05);\n  --bs-rating-color-default: #C4CADA;\n  --bs-rating-color-active: #FFAD0F;\n  --bs-ribbon-label-box-shadow: 0px -1px 5px 0px rgba(30, 33, 41, 0.1);\n  --bs-ribbon-label-bg: #1B84FF;\n  --bs-ribbon-label-border-color: #0053b4;\n  --bs-ribbon-clip-bg: #1E2129;\n  --bs-engage-btn-bg: #ffffff;\n  --bs-engage-btn-box-shadow: 0px 0px 22px #E0E0E0;\n  --bs-engage-btn-border-color: #E8E8E8;\n  --bs-engage-btn-color: #252F4A;\n  --bs-engage-btn-icon-color: #78829D;\n  --bs-engage-btn-color-active: #252F4A;\n}\n\n\n\n\n\n/* .table-responsive {\n  overflow: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\ntable.dataTable {\n  width: 100% !important;\n  margin: 0 !important;\n}\n\n.table:not(.table-bordered).table-row-dashed tr {\n  border-bottom-width: 1px;\n  border-bottom-style: dashed;\n  border-bottom-color: var(--bs-border-color);\n}\n\n.table:not(.table-bordered) tr:last-child, .table:not(.table-bordered) th:last-child, .table:not(.table-bordered) td:last-child {\n  padding-right: 0;\n}\n\n.table:not(.table-bordered) tr:first-child, .table:not(.table-bordered) th:first-child, .table:not(.table-bordered) td:first-child {\n  padding-left: 0;\n}\n\n.table:not(.table-bordered) tr, .table:not(.table-bordered) th, .table:not(.table-bordered) td {\n  border-color: inherit;\n  border-width: inherit;\n  border-style: inherit;\n  text-transform: inherit;\n  font-weight: inherit;\n  font-size: inherit;\n  color: inherit;\n  height: inherit;\n  min-height: inherit;\n}\n\n.table:not(.table-bordered) > :not(:last-child) > :last-child > * {\n  border-bottom-color: inherit;\n}\n\n.table:not(.table-bordered) tr:first-child, .table:not(.table-bordered) th:first-child, .table:not(.table-bordered) td:first-child {\n  padding-left: 0;\n}\ntable.dataTable > thead > tr > td:not(.sorting_disabled), table.dataTable > thead > tr > th:not(.sorting_disabled) {\n  padding-right: 0;\n}\n\ntable.dataTable th {\n  border-bottom-color: var(--bs-table-border-color);\n}\n\n.table > :not(caption) > * > * {\n  padding: 0.75rem 0.75rem;\n  color: var(--bs-table-color-state, var(--bs-table-color-type, var(--bs-table-color)));\n  background-color: var(--bs-table-bg);\n  border-bottom-width: 1px;\n  box-shadow: inset 0 0 0 9999px var(--bs-table-bg-state, var(--bs-table-bg-type, var(--bs-table-accent-bg)));\n}\n\n.table.gy-5 th, .table.gy-5 td {\n  padding-top: 1.25rem;\n  padding-bottom: 1.25rem;\n}\n\n.table:not(.table-bordered) tr:last-child, .table:not(.table-bordered) th:last-child, .table:not(.table-bordered) td:last-child {\n  padding-right: 0;\n}\n\n.form-check {\n  display: block;\n  min-height: 1.5rem;\n  padding-left: 2.25rem;\n  margin-bottom: 0.125rem;\n}\n\n.form-check-custom {\n  display: flex;\n  align-items: center;\n  padding-left: 0;\n  margin: 0;\n}\n\n.form-check-input {\n  --bs-form-check-bg: transparent;\n  width: 1.75rem;\n  height: 1.75rem;\n  margin-top: -0.125rem;\n  vertical-align: top;\n  background-color: var(--bs-form-check-bg);\n  background-image: var(--bs-form-check-bg-image);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: 1px solid var(--bs-gray-300);\n  appearance: none;\n  print-color-adjust: exact;\n}\n\n.form-check .form-check-input {\n  float: left;\n  margin-left: -2.25rem;\n}\n\n.form-check-input[type=checkbox] {\n  border-radius: 0.45em;\n}\n\n.form-check-custom .form-check-input {\n  margin: 0;\n  float: none;\n  flex-shrink: 0;\n}\n\n.form-check.form-check-sm .form-check-input {\n  height: 1.55rem;\n  width: 1.55rem;\n}\n\n.form-check.form-check-solid .form-check-input {\n  border: 0;\n}\n\n.form-check:not(.form-switch) .form-check-input[type=checkbox] {\n  background-size: 60% 60%;\n}\n\n.form-check.form-check-solid .form-check-input:not(:checked) {\n  background-color: var(--bs-gray-200);\n} */\n\n\n.flatpickr-calendar {\n  width: 280px!important;\n  font-family: inherit;\n  border: 0;\n  border-radius: 0;\n  box-shadow: var(--bs-dropdown-box-shadow);\n  background-color: var(--bs-body-bg);\n  border-radius: 0.475rem;\n}\n\n.flatpickr-weekdays {\n  background: transparent;\n  text-align: center;\n  overflow: hidden;\n  width: 100%;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n  height: 28px;\n}\n\n\nspan.flatpickr-weekday {\n  color: var(--bs-gray-800);\n  font-size: 1rem;\n  font-weight: 600;\n}\nspan.flatpickr-weekday {\n  cursor: default;\n  font-size: 90%;\n  background: transparent;\n  color: #0000008a;\n  line-height: 1;\n  margin: 0;\n  text-align: center;\n  display: block;\n  -webkit-box-flex: 1;\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  font-weight: bolder;\n}\n\n.flatpickr-days {\n  position: relative;\n  overflow: hidden;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: start;\n  -webkit-align-items: flex-start;\n  -ms-flex-align: start;\n  align-items: flex-start;\n  width: 307.875px;\n  border: none;\n}\n\n.dayContainer {\n  padding: 0;\n  outline: 0;\n  text-align: left;\n  width: 307.875px;\n  min-width: 307.875px;\n  max-width: 307.875px;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  display: inline-block;\n  display: -ms-flexbox;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: flex;\n  -webkit-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  -ms-flex-pack: justify;\n  -webkit-justify-content: space-around;\n  justify-content: space-around;\n  -webkit-transform: translate3d(0px,0px,0px);\n  transform: translateZ(0);\n  opacity: 1;\n}\n\n\n.flatpickr-day {\n  font-size: 1rem;\n  border-radius: 0.475rem;\n  box-shadow: none !important;\n  height: 36px;\n  width: 100%;\n  max-width: 100%!important;\n  margin: 0;\n  line-height: 36px;\n  color: var(--bs-gray-600);\n  margin-top: 0!important;\n}\n\n\n.flatpickr-day {\n  background: none;\n  border: 1px solid transparent;\n  border-radius: 150px;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  color: #393939;\n  cursor: pointer;\n  font-weight: 400;\n  width: 14.2857143%;\n  -webkit-flex-basis: 14.2857143%;\n  -ms-flex-preferred-size: 14.2857143%;\n  flex-basis: 14.2857143%;\n  max-width: 39px;\n  height: 39px;\n  line-height: 39px;\n  margin: 0;\n  display: inline-block;\n  position: relative;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  text-align: center;\n}\n\n\n\n\n.flatpickr-day.selected, .flatpickr-day.startRange, .flatpickr-day.endRange, .flatpickr-day.selected.inRange, .flatpickr-day.startRange.inRange, .flatpickr-day.endRange.inRange, .flatpickr-day.selected:focus, .flatpickr-day.startRange:focus, .flatpickr-day.endRange:focus, .flatpickr-day.selected:hover, .flatpickr-day.startRange:hover, .flatpickr-day.endRange:hover, .flatpickr-day.selected.prevMonthDay, .flatpickr-day.startRange.prevMonthDay, .flatpickr-day.endRange.prevMonthDay, .flatpickr-day.selected.nextMonthDay, .flatpickr-day.startRange.nextMonthDay, .flatpickr-day.endRange.nextMonthDay {\n  background-color: #21364B;\n  color: white;\n}\n\n.bg-warning-reminder { \n  background-color: #F6700E !important;\n}\n\n.bg-success-reminder { \n  background-color: #1B6E53 !important;\n}\n\n.bg-danger-reminder { \n  background-color: #E01507 !important;\n}\n\n.form-check-input:checked {\n  background-color: #21364B;\n  border-color: #21364B;\n}\n\n\n.pac-container {\n  z-index: 1201 !important;\n}\n\n\n.gm-style-iw button[title=\"Close\"] {\n  display: none !important;\n}\n\n.gm-style-iw-chr {\n  display: none;\n}\n\n.gm-style .gm-style-iw-c {\n  padding: 0;\n}\n\n.gm-style-iw-d {\n  padding: 0;\n  overflow: hidden !important;\n}\n\n.listing-carousel {\n  display: grid;\n  grid-template-columns: 50% 1fr 1fr;\n  grid-template-rows: 1fr 1fr;\n  grid-auto-flow: row;\n}\n\n.listing-carousel-1 {\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-template-rows: 1fr 1fr;\n  grid-auto-flow: row;\n}\n\n.listing-carousel-2 {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  grid-template-rows: 1fr 1fr;\n  grid-auto-flow: row;\n}\n\n\n.listing-carousel-item-1 {\n  grid-column: 1;\n  grid-row: 1 / 3;\n}\n\n.listing-carousel-item-2 {\n  grid-column: 2;\n  grid-row: 1 / 3;\n}\n\n@media only screen and (max-width: 1200px) {\n  .listing-carousel {\n    grid-template-columns: 1fr;\n  }\n\n  .listing-carousel-1 {\n    grid-template-columns: 1fr;\n  }\n\n  .listing-carousel-2 {\n    grid-template-columns: 1fr ;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
